import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { Button } from '../button';
import { PaperclipIcon } from '../icons/content/paperclip-icon';
import { TrashIcon } from '../icons/content/trash-icon';
import { RefreshIcon } from '../icons/internet/refresh-icon';
const Root = styled.div `
  background: ${(props) => `${props.theme.color.black[50]}`};
  color: ${(props) => props.theme.color.white[100]};

  justify-content: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;

  height: 54px;
  border-radius: 50px;
  font-weight: 500;
  line-height: 1;
  gap: 5px;
  border-radius: 20px;
  gap: 20px;
  padding: 0 10px;

  transition: all 100ms ease-in;
`;
const Action = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;
const Text = styled.p `
  color: ${(props) => props.theme.color.gray2[100]};
  font-weight: 300;
  font-size: 14px;
  font-style: italic;
  margin-left: 10px;
`;
const Input = styled.input `
  display: none;
`;
export const ResetButton = styled(Button) `
  color: var(--error-9);
`;
export const File = ({ text, add, replace, input, ...props }) => {
    const [file, setFile] = useState(null);
    const ref = useRef(null);
    const onFileChange = (event) => {
        if (event.target.files) {
            setFile(event.target.files[0] || null);
        }
        if (input.onChange) {
            input.onChange(event);
        }
    };
    const onAddClick = () => {
        ref.current?.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    };
    const onResetClick = () => {
        setFile(null);
        if (ref.current) {
            ref.current.value = '';
            ref.current?.dispatchEvent(new Event('change'));
        }
    };
    return (_jsxs(Root, { ...props, children: [_jsx(Input, { ref: ref, type: "file", onChange: onFileChange, ...input }), file ? (_jsxs(_Fragment, { children: [_jsx(Text, { children: file.name }), _jsxs(Action, { children: [_jsx(ResetButton, { size: "s", onClick: onResetClick, iconLeft: _jsx(TrashIcon, {}) }), _jsx(Button, { ...replace, onClick: onAddClick, iconLeft: _jsx(RefreshIcon, { size: 20, width: 20 }) })] })] })) : (_jsxs(_Fragment, { children: [_jsx(Text, { children: text }), _jsx(Action, { children: _jsx(Button, { ...add, onClick: onAddClick, iconLeft: _jsx(PaperclipIcon, { size: 20, width: 20 }) }) })] }))] }));
};
//# sourceMappingURL=file.js.map